import { render, staticRenderFns } from "./billboard.vue?vue&type=template&id=a9b79674&scoped=true&"
import script from "./billboard.vue?vue&type=script&lang=js&"
export * from "./billboard.vue?vue&type=script&lang=js&"
import style0 from "./billboard.vue?vue&type=style&index=0&id=a9b79674&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b79674",
  null
  
)

export default component.exports